var WebEventTracker = (function () {
  var logEvent = function (eventType, key, data) {
    var pageSlug = window.location.pathname,
      paramsObj = {},
      loadEDS = false;
    pageSlug = pageSlug.replace(/^\/|\/$/g, '');

    //Add Query parameter in json in event data with name of "params"
    if (window.location.search != '') {
      var paramsValue = {},
        whiteListParams = [
          'adgroupi',
          'adid',
          'campaign',
          'campaignid',
          'device',
          'gclid',
          'matchtype',
          'query',
          'ref',
          'utm_adgroup',
          'utm_agn',
          'utm_campaign',
          'utm_content',
          'utm_keyword',
          'utm_matchtype',
          'utm_medium',
          'utm_source',
          'utm_term',
          'cta',
        ],
        paramsObj = location.search
          .slice(1)
          .split('&')
          .map(function (p) {
            return p.split('=');
          })
          .reduce(function (obj, pair) {
            if (pair.length >= 2) {
              obj[pair[0]] = pair[1];
            }
            return obj;
          }, {});


      //Read from cookie
      if (Object.keys(paramsObj).length == 0) {
        var cookieUtmParams = Cookie.read(stage_env_cookie_prefix + "user_utm_data");
        if (cookieUtmParams) {
          paramsObj = bsLib.JSONParse(cookieUtmParams);
        }
      }

      // check white list params
      Object.keys(paramsObj).forEach(function (key) {
        if (whiteListParams.indexOf(key) > -1) {
          paramsValue[key] = paramsObj[key];
        }
      });

      //if params set then add params props
      if (Object.keys(paramsValue).length > 0) {
        data['params'] = paramsValue;
      }
    }

    //Add product params for Exclusive Pack
    if (key === 'BrowserstackPackPage') {
      data['product'] = (paramsObj['webinar_product'] !== undefined ? paramsObj['webinar_product'] : 'live');
    }

    if ((((pageSlug === "") && key === "OnMainLandingPage")
       || (pageSlug === "automate" && key === "OnAutomateMarketingPage")
       || (pageSlug === "app-automate" && key === "OnAppAutomateMarketingPage")
       || (pageSlug === "percy" && key === "OnPercyMarketingPage")
       || (pageSlug === "how-to-debug-on-iphone" && key === "LoadArticle")
       || (pageSlug === "how-to-inspect-element-on-iphone" && key === "LoadArticle"))
       && popUpCSFOptions.vwoShow
       && popUpCSFOptions.source !== "" ) {
      data['action'] = popUpCSFOptions.source;
    }

    // header menu experiment
    if ((pageSlug === "") && (key === "OnMainLandingPage" || key === "InteractedWithHomePage")) {
      data['menu_exp'] = headerMenuExpProps;
    }

    //Remove blank entry
    Object.keys(data).forEach(function (key) {
      if (data[key] === "") {
        delete data[key];
      }
    });

    window.hasOwnProperty('Amplitude') ? Amplitude.logEvent(key, data) : '';

    //Load EDS Event with page slug condition
    switch (pageSlug) {
      case 'automate':
      case 'app-automate':
      case 'enterprise':
      case 'data-centers':
      case 'security':
      case 'customers':
      case 'case-study':
      case 'careers':
      case 'live':
      case 'app-live':
      case 'open-source':
      case 'percy':
        var arrEvt = [
          'OnAutomateMarketingPage',
          'OnAppAutomateMarketingPage',
          'OnMarketingFeaturePage',
          'OnCasestudyPage',
          'OnCareersPage',
          'InteractedWithTeamWidePlanBanner',
          'OnLiveMarketingPage',
          'OnAppLiveMarketingPage',
          'OnPercyMarketingPage',
          'OnOpenSourcePage',
          'OpenSourceForm',
          'InteractedWithOpenSourcePage',
        ];
        if (arrEvt.indexOf(key) !== -1) {
          loadEDS = true;
        }
        break;
      default:
    }

    if ((pageSlug === "") && key === "OnMainLandingPage") {
      key = "OnHomePageNew";
    }

    // Switch case added based on Event Name.
    switch (key) {
      case 'OnMarketingFeaturePage':
      case 'OnLowCodeAutomationMarketingpage':
      case 'OnCasestudyPage':
      case 'VisitedIntegrationPage':
      case 'InteractedWithIntegrationsPage':
      case 'FreshChat':
      case 'ClickonGlobalSearchIcon':
      case 'TriggerGlobalSearch':
      case 'GlobalDynamicResultClicked':
      case 'guideFeedbackGiven':
      case 'guideVerboseFeedbackGiven':
      case 'LoadContactForm':
      case 'OnSignUpPage':
      case 'InteractedWithSignUpPage':
      case 'CsfInteractedWithNameField':
      case 'CsfInteractedWithEmailField':
      case 'CsfInteractedWithCompanyField':
      case 'CsfInteractedWithMessageField':
      case 'CsfInteractedWithPhonenumberField':
      case 'CsfInteractedWithCountryField':
      case 'CsfInteractedWithJobtitleField':
      case 'InteractedWithSalesForm':
      case 'CsfInteractedWithCheckbox':
      case 'CsfInteractedWithUsecaseField':
      case 'CsfInteractedWithCaptcha':
      case 'SubmitContactForm':
      case 'CsfInteractedWithCloseButton':
      case 'RevenueHeroTriggered':
      case 'InteractedWithHomePage':
      case 'InteractedwithProductCard':
      case 'ProductTabToggled':
      case 'LoadArticle':
      case 'OnCompliancePage':
      case 'InteractedWithArticlePage':
      case 'onSupportPage':
      case 'InteractedWithCompanyPage':
      case 'OnCompanyPage':
      case 'FaqSupportSearchFocus':
      case 'FaqSupportSearchSubmit':
      case 'FaqSupportProductClicked':
      case 'FaqSupportFolderClicked':
      case 'FaqSupportBreadCrumbClicked':
      case 'FaqSupportFaqClicked':
      case 'FaqSupportDocsSupportClicked':
      case 'FaqBottomContactUsClicked':
      case 'FaqStatusPageSupportClicked':
      case 'FaqContactPageSupportClicked':
      case 'FAQFeedbackGiven':
      case 'ReadFAQ':
      case 'ClickedOnFooter':
      case 'clickedTryAppLiveHeroCta':
      case 'hcaptchaVisitedWp':
      case 'VisitedHelpDesk':
      case 'InteractedonHelpDesk':
      case 'FAQSuggestedLinkClicks':
      case 'FaqSupportProductVisited':
      case 'FaqSupportDynamicSearchClicked':
      case 'FaqSupportDynamicSearchInitiated':
      case 'GlobalDynamicSearchInitiated':
      case 'ClickedOnSecondaryHeader':
      case 'DemoExDemoCTAClicked':
      case 'DemoExCorporateLoaderDisplay':
      case 'SubmitGuideSubscriptionForm':
      case 'HoveredOnSecondaryHeader':
      case 'OnTrustCenterCertificate':
      case 'OnTrustCenter':
      case 'CertificateRequested':
      case 'CookieConsentBannerShown':
      case 'InteractedWithCookieConsentBanner':
      case 'OnClickFeaturedArticle':
      case 'OnClickGuideTag':
      case 'ClickedRelatedArticle':
      case 'OnBugCaptureMarketingpage':
      case 'OnTestManagementMarketingPage':
      case 'OnAccessibilityHomepage':
      case 'InteractedWithBugCaptureMarketingpage':
      case 'beb_tnc_modal_view':
      case 'beb_tnc_modal_accept':
      case 'beb_tnc_modal_cancelled':
      case 'VisitedDiscordInvitePage':  
      case 'InteractedWithDiscordForm':
      case 'SubmitDiscordForm':
      case 'OnWebsiteScannerMarketingPage':
      case 'visitedPodcastPage':
      case 'InteractedwithPodcastPage':
      case 'InteractedWithWebsiteScannerMarketingPage':
      case 'OnOSLandingPage':
      case 'OnThankyouPage':
        loadEDS = true;
        break;
      case 'OnHomePageNew':
      case 'OnHomePage':
        if (paramsObj['ref'] === 'caniuse-source') {
          data['params'] = paramsObj;
        }
        loadEDS = true;
        break;
      case 'CaniuseReferral':
        data['params'] = paramsObj;
        loadEDS = true;
        break;
      case 'InteractedWithLiveMarketingPage':
          loadEDS = true;
        break;
      case 'OnCasestudyPage':
        if (pageSlug.indexOf('case-study/') === 0) {
          loadEDS = true;
        }
        break;
      default:
    }

    if (loadEDS) {
      var intVar = 0;
      var pageEDSInterval = setInterval(function () {
        if (EDS.hasOwnProperty('logEvent')) {
          EDS.logEvent(key, eventType, data);
          clearInterval(pageEDSInterval);
        }
        if (intVar > 10) {
          clearInterval(pageEDSInterval);
        }
        intVar += 1;
      }, 300);
    }
  };

  return { logEvent: logEvent };
})();
